import ReportBase from 'app/models/report_base';

export default ReportBase.extend({
  reportType: 'tracker',
});



// WEBPACK FOOTER //
// ./app/models/tracker_report.js